import { useState, useRef, useCallback, useMemo, useEffect, useLayoutEffect } from "react";

import { Input, Switch } from "@mui/material";

import kutil from "@modules/kutil";

import { usePopup } from "@components/popup/popup_context";

interface Props {
  workEquip: string;
};

interface Info {
  workEquip: string;
  ip: string;
  port: number | "";
  connectYn: string;
};

const defInfo: Info = {
  workEquip: "",
  ip: "",
  port: 0,
  connectYn: "N"
};

const validationMsg = [
  {id: "workEquip", type: "INVALID_EQUIP", msg: "설비정보가 올바르지 않습니다."},
  {id: "workEquip", type: "NotBlank", msg: "설비를 선택해 주세요."},
  {id: "ip", type: "NotBlank", msg: "IP를 입력해 주세요."},
  {id: "port", type: "NotBlank", msg: "PORT를 입력해 주세요."},
];

const WORK_EQUIP: Record<string, string>  = {
  "PLCManager": "MFC",
  "SC01": "STC1",
  "SC02": "STC2",
  "SC03": "STC3",
  "SC04": "STC4",
  "SC05": "STC5",
  "SC06": "STC6",
  "SC07": "STC7",
  "RV41": "RGV1",
  "CV31": "PLC1",
  "CV32": "PLC2",
};

export default function EquipConfig(props: Props) {
  const [info, setInfo] = useState<Info>(kutil.deepCopy(defInfo));

  const { setOption, setActions, onClose } = usePopup();

  const saveRef = useRef(save);
  saveRef.current = save;

  const workEquip = props.workEquip;
  const workEquipName = WORK_EQUIP[workEquip];

  useLayoutEffect(() => {
    setOption({
      title: workEquipName,
      maxWidth: "700px"
    });
    setActions([
      {
        id: "closePopup",
        label: "닫기",
        className: "basic outline",
        onClick: () => onClose(),
      },
      {
        id: "save",
        label: "저장",
        className: "basic fill",
        onClick: () => saveRef.current(),
      },
    ]);
  }, []);

  useEffect(() => {
    searchInfo();
  }, []);

  async function searchInfo() {
    if (!workEquip) {
      return;
    }

    try {
      const data = await kutil.sendGet("/api/work/equip_config.data?mode=search", {workEquip: workEquip}, {});
      setInfo(data.info);
    } catch(e) {
      console.log(e);
    }
  }

  async function save() {
    if (info.workEquip != "PLCManager") {
      const isValid = await kutil.checkValidation(info, validationMsg);
      if (isValid == false) {
        return;
      }
    }

    if (await kutil.confirm("저장하시겠습니까?") == false) {
      return false;
    }

    try {
      const data = await kutil.sendPost("/api/work/equip_config.proc?mode=save", info, {
        validationMsg: validationMsg
      });

      await kutil.alert("저장되었습니다.");
      onClose();
    } catch(e) {
      console.log(e);
    }
  }

  return (
    <>
      <div className="popup-contents">
        <div className="table-wrap">
          <table>
            <colgroup>
              <col style={{ width: "33.3%" }} />
              <col style={{ width: "66.6%" }} />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">작업설비</th>
                <td>
                  {workEquipName}
                </td>
              </tr>
            { workEquip != "PLCManager" &&
              <tr>
                <th scope="row">IP</th>
                <td>
                  <Input
                    inputProps={{ maxLength: 100 }}
                    value={info.ip}
                    onChange={(e) => {setInfo(prev => ({ ...prev, ip: e.target.value }))}}
                    onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                    disabled={info.workEquip=="PLCManager"}
                  />
                </td>
              </tr>
            }
            { workEquip != "PLCManager" &&
              <tr>
                <th scope="row">Port</th>
                <td>
                  <Input
                    inputProps={{ maxLength: 100 }}
                    value={info.port}
                    onChange={(e) => {setInfo(prev => ({ ...prev, port: kutil.toInt(e.target.value, 0) || "" }))}}
                    onKeyDown={(e) => {kutil.onKeyDownForInput(e, save)}}
                    disabled={info.workEquip=="PLCManager"}
                  />
                </td>
              </tr>
            }
              <tr>
                <th scope="row">{info.workEquip == "PLCManager" ? "실행여부" : "연결여부"}</th>
                <td>
                  <Switch
                    checked={info.connectYn === "Y"}
                    onChange={(_, checked) => setInfo((prev) => ({ ...prev, connectYn: checked ? "Y" : "N" }))}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
